// src/components/Navbar.jsx
import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const navItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Experience", path: "/experience" },
  { name: "Travel", path: "/travel" },
  { name: "Projects", path: "/projects" },
  { name: "Media", path: "/media" },
  { name: "Contribution", path: "/contribution" },
  { name: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dark, setDark] = useState(true);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Theme toggle
  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
      setDark(true);
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [dark]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-900/90 shadow-lg py-2"
          : "bg-slate-900/40 backdrop-blur-md py-4"
      }`}
    >
      <nav className="max-w-7xl mx-auto flex justify-between items-center px-6">
        {/* Brand */}
        <Link to="/">
          <h1 className="text-2xl font-extrabold tracking-wide bg-gradient-to-r from-indigo-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            Janardan Nepal
          </h1>
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-8 font-medium text-lg">
          {navItems.map((item) => (
            <li key={item.name} className="relative group">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `transition duration-300 ${
                    isActive
                      ? "text-indigo-400"
                      : "text-gray-200 hover:text-white"
                  }`
                }
              >
                {item.name}
              </NavLink>
              {/* Animated underline */}
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-gradient-to-r from-indigo-400 to-pink-400 transition-all duration-300 group-hover:w-full"></span>
            </li>
          ))}
        </ul>

        {/* Right Icons */}
        <div className="flex items-center gap-6">
          {/* Theme toggle */}
          {/* <button
            onClick={() => setDark(!dark)}
            className="text-xl text-gray-300 hover:text-yellow-400 transition"
          >
            {dark ? <FaSun /> : <FaMoon />}
          </button> */}

          {/* Mobile Menu Button */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-gray-200 text-2xl focus:outline-none"
          >
            {open ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div
        className={`fixed  top-0 right-0 h-full w-64 bg-slate-900 shadow-xl transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex  justify-between items-center px-6 py-4 border-b border-slate-700">
          <h2 className="text-lg font-bold text-indigo-400">Menu</h2>

          <button
            onClick={() => setOpen(false)}
            className="text-2xl text-gray-300"
          >
            <FaTimes />
          </button>
        </div>
        <ul className="flex flex-col bg-black gap-6 px-6 py-8 text-lg">
          {navItems.map((item) => (
            <li key={item.name}>
              <NavLink
                to={item.path}
                className="block text-gray-300 hover:text-indigo-400 transition"
                onClick={() => setOpen(false)}
              >
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
